import { render } from "./MenuManagement.vue?vue&type=template&id=6aee85e5&scoped=true"
import script from "./MenuManagement.vue?vue&type=script&lang=js"
export * from "./MenuManagement.vue?vue&type=script&lang=js"

import "./MenuManagement.vue?vue&type=style&index=0&id=6aee85e5&scoped=true&lang=css"

import exportComponent from "/home/cm/project/golinker/admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aee85e5"]])

export default __exports__